var WebStorageCache = /** @class */ (function () {
    function WebStorageCache(props) {
        var _this = this;
        /**
         * 判断当前环境是否支持local storage
         * const a = new WebStorageCache();
         * if (a.isSupport()) { a.set(); a.get(); }
         * @returns boolean
         */
        this.isSupport = function () {
            var cache;
            var storage = _this.config.storage;
            try {
                cache = window[storage];
                _this.storage = cache;
                var x = '__storage_test__';
                cache.setItem(x, x);
                cache.removeItem(x);
                return true;
            }
            catch (e) {
                _this.storage = undefined;
                return false;
            }
        };
        this._isValidDate = function (date) {
            return Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date.getTime());
        };
        this.quotaExceedHandler = function (key, val, options, e) {
            console.warn('Quota exceeded!');
            if (options && options.force === true) {
                _this.deleteAllExpired();
                try {
                    options.force = false;
                    _this.set(key, val, options);
                }
                catch (err) {
                    console.warn(err);
                }
            }
        };
        this._getExpiredDate = function (expire) {
            var nowDate = new Date();
            var expireDate;
            if (typeof expire === 'number') {
                expireDate = expire === 0 ? _this._defaultExpired : new Date(nowDate.getTime() + expire * 1000);
            }
            else if (typeof expire === 'string') {
                expireDate = new Date(expire);
            }
            else if (expire && !_this._isValidDate(expire)) {
                throw new Error('expire should be a normal date');
            }
            else {
                expireDate = _this._defaultExpired;
            }
            return expireDate;
        };
        this._warpStorageKey = function (key) {
            return "security-sdk/".concat(key);
        };
        /**
         * 存储数据
         * @param key string 存储key
         * @param value value string 需要存储的信息 对象请使用 JSON.stringfy()
         * @param options 存储选项
         * @returns void
         */
        this.set = function (key, value, options) {
            if (!_this.storage) {
                throw new Error('browser is not support storage');
            }
            var warpKey = _this._warpStorageKey(key);
            if (typeof value === 'undefined') {
                _this.delete(warpKey);
                return;
            }
            var val = value;
            var item = _this._cacheItemProcess(warpKey, val, options);
            try {
                _this.storage.setItem(warpKey, JSON.stringify(item));
            }
            catch (e) {
                if (_this._checkQuotaExceeded(e)) {
                    _this.quotaExceedHandler(warpKey, val, options, e);
                }
                else {
                    console.error(e);
                }
            }
        };
        // https://developer.mozilla.org/zh-CN/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API
        this._checkQuotaExceeded = function (e) {
            var quotaExceeded = false;
            if (e) {
                if (e.code) {
                    // eslint-disable-next-line default-case
                    switch (e.code) {
                        case 22:
                            quotaExceeded = true;
                            break;
                        case 1014:
                            // eslint-disable-next-line max-depth
                            if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED' || e.name === 'QuotaExceededError') {
                                quotaExceeded = true;
                            }
                            break;
                    }
                }
                else if (e.number === -2147024882) {
                    // Internet Explorer 8
                    quotaExceeded = true;
                }
            }
            return quotaExceeded;
        };
        this._cacheItemProcess = function (key, val, options) {
            var expire = (options || {}).expire;
            var exp = expire || _this.config.expire;
            var createTime = new Date().getTime();
            var expireData = _this._getExpiredDate(exp);
            var item = {
                key: key,
                data: val,
                createTime: createTime,
                expireTime: expireData.getTime(),
            };
            return item;
        };
        this._checkCacheItemIsEffective = function (item) {
            var time = new Date().getTime();
            var expireTime = item.expireTime;
            return expireTime > time;
        };
        this._checkCacheItem = function (item) {
            if (typeof item !== 'object') {
                return false;
            }
            if (item) {
                if ('data' in item && 'expireTime' in item && 'createTime' in item && 'key' in item) {
                    return true;
                }
            }
            return false;
        };
        /**
         * 获取当前local storage 数据
         * @param key string 存储时的key
         * @returns value string
         */
        this.get = function (key) {
            var _a;
            var warpKey = _this._warpStorageKey(key);
            var cacheItem;
            try {
                cacheItem = (_a = _this.storage) === null || _a === void 0 ? void 0 : _a.getItem(warpKey);
            }
            catch (error) {
                return null;
            }
            if (cacheItem) {
                cacheItem = JSON.parse(cacheItem);
            }
            if (_this._checkCacheItem(cacheItem)) {
                if (_this._checkCacheItemIsEffective(cacheItem)) {
                    var data = cacheItem === null || cacheItem === void 0 ? void 0 : cacheItem.data;
                    return data;
                    // try {
                    // } catch (error) {
                    //   return null;
                    // }
                }
                else {
                    _this.delete(key);
                }
            }
            return null;
        };
        /**
         * 删除当前存储数据
         * @param key string 存储时填写的key
         * @returns void
         */
        this.delete = function (key) {
            var _a;
            var warpKey = _this._warpStorageKey(key);
            (_a = _this.storage) === null || _a === void 0 ? void 0 : _a.removeItem(warpKey);
            return;
        };
        this.deleteAllExpired = function () {
            var _a, _b, _c;
            var length = ((_a = _this.storage) === null || _a === void 0 ? void 0 : _a.length) || 0;
            var deleteKeys = [];
            for (var i = 0; i < length; i++) {
                var key = ((_b = _this.storage) === null || _b === void 0 ? void 0 : _b.key(i)) || '';
                var cacheItem = null;
                try {
                    cacheItem = (_c = _this.storage) === null || _c === void 0 ? void 0 : _c.getItem(key);
                    cacheItem = cacheItem && JSON.parse(cacheItem);
                    // eslint-disable-next-line prettier/prettier
                }
                catch (e) { }
                if (cacheItem && cacheItem.createTime !== undefined) {
                    var now = new Date().getTime();
                    if (now >= cacheItem.createTime) {
                        deleteKeys.push(key);
                    }
                }
            }
            deleteKeys.forEach(function (key) {
                _this.delete(key);
            });
            return deleteKeys;
        };
        /**
         * 清空当前数据   use:  cacheSDK.clear();
         */
        this.clear = function () {
            var _a;
            (_a = _this.storage) === null || _a === void 0 ? void 0 : _a.clear();
        };
        this.config = props || { storage: 'localStorage' };
        var _maxExpireDate = new Date('Fri, 31 Dec 2099 23:59:59 UTC');
        this._defaultExpired = _maxExpireDate;
    }
    return WebStorageCache;
}());
export default WebStorageCache;
